import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";

import product1 from "../../assets/product1.jpg";
import product2 from "../../assets/product2.jpg";
import product3 from "../../assets/product3.jpg";
import product4 from "../../assets/product4.jpg";
function ProductSlider() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);
  return (
    <div className="slider-container">
      <Slider asNavFor={nav2} ref={(slider) => (sliderRef1 = slider)}>
        <div>
          <img src={product1} alt="product" />
        </div>
        <div>
          <img src={product2} alt="product" />
        </div>
        <div>
          <img src={product3} alt="product" />
        </div>
        <div>
          <img src={product4} alt="product" />
        </div>
      </Slider>

      {/* second slider */}
      <div className="nav-slider">
        <Slider
          asNavFor={nav1}
          ref={(slider) => (sliderRef2 = slider)}
          slidesToShow={3}
          swipeToSlide={true}
          focusOnSelect={true}
          centerMode={true}
        >
          <div>
            <img src={product1} alt="product" />
          </div>
          <div>
            <img src={product2} alt="product" />
          </div>
          <div>
            <img src={product3} alt="product" />
          </div>
          <div>
            <img src={product4} alt="product" />
          </div>
        </Slider>
      </div>
    </div>
  );
}

export default ProductSlider;
